<script>
import env from '@/env'
import {mapState} from 'vuex'
import VContentCard from '@/components/VContentCard'
import auth from '@/auth'

const VWarningMessage = () => import('@/components/VWarningMessage')
const VImageTransition = () => import('@/components/VImageTransition')

export default {
  name: 'AuthLoadingScreen',
  components: {
    VContentCard,
    VWarningMessage,
    VImageTransition,
  },
   props: {
    code: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      errorMessage: '',
    };
  },

  computed: {
    ...mapState({
      clientLogo: 'clientLogo',
      clientName: 'clientName',
      isLoading: 'isLoading',
    }),
  },
  mounted() {
    this.init()
  },

  beforeMount() {
    this.$store.dispatch('SEARCH_CLIENT_CONFIG')
  },

  methods: {
    init(){
      this.$store.dispatch('START_LOADING');
      
      auth.getCognitoToken(this.code)
        .then(auth.store)
        .then(auth.generateSession)
        .then(() => {
          this.$store.dispatch('STOP_LOADING');
          window.location.assign(env.redirectPath());
        })
        .catch((error) => {
          this.$store.dispatch('STOP_LOADING');
          this.errorMessage = error.message;
        });
    }
  }
}
</script>

<template>
  <VContentCard>
    <template slot="form">
      <div class="auth_sso">

        <div class="auth_sso__logo-content">
          <VImageTransition
            :image="clientLogo" 
            :text="clientName"
          />
        </div>
        <div 
          v-if="errorMessage" 
          class="login-form__warning-content">
          <VWarningMessage 
            class="login-form__warning" 
            error>
            {{ errorMessage }}
          </VWarningMessage>
          <div class="back-container">
            <router-link 
              :to="{ name: 'loginScreen' }" 
              class="inv-text-link">
              {{ $t("backToMainScreen") }}
            </router-link>
          </div>
        </div>
        <div 
          v-if="!errorMessage" 
          class="auth_sso__content">
          <div 
            v-if="isLoading " 
            class="auth_sso__title">
            {{ $t("wait") }}
          </div>

          <div 
            v-if="isLoading " 
            class="auth_sso__description" >
            {{ $t("youWillBeRedirected") }}
          </div>
        </div>

      </div>
    </template>
  </VContentCard>
</template>

<style scoped>
.button-link {
  max-width: 288px;
  width: 100%;
  min-height: 60px;
  background-color: #4693F8;
  text-decoration: none;
}

.auth_sso {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 480px;
  margin-top: var(--space-24);
  margin-bottom: var(--space-24);
}

.auth_sso__logo-content {
  min-height: 108px;
}

.auth_sso__content {
  margin-top: 88px;
}

.auth_sso__title {
  text-align: center;
  font-weight: var(--font-title--weight);
  font-size: var(--font-title--size);
  color: var(--color-default--dark);
}

.auth_sso__description {
  margin-top: 6px;
  font-size: var(--font-content--size);
  color: var(--color-system--dark);
  align-self: center;
  text-align: center;
}

.inv-btn {
  margin-top: 125px;
  text-decoration: none;
  box-sizing: border-box;
}

.login-form__warning-content {
  min-height: 24px;
  padding-top: var(--space-8);
  padding-bottom: var(--space-8);
}

.back-container {
  display: flex;
  justify-content: center;
  margin-top: var(--space-8);
}

</style>